import { DETAILS } from "./details.data";
import styles from "./index.module.scss";
import parse from "html-react-parser";

const Details = ({ details }) => {
  return (
    <div className={styles.detailsWrapper}>
      {/* <ul className={styles.detailPoints}>
        {details.map((detail, index) => {
          return <li key={index}>{detail}</li>;
        })}
      </ul> */}
      {parse(details.content)}
    </div>
  );
};

export default Details;
